module.exports = __webpack_public_path__ + "static/media/Pain3.95f930a3.png";